import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../../../styles/dashboardTheme.css";
import "../../../../styles/managementTheme.css";
import "../styles/formaciones.css";
import FormacionesSummary from "../components/FormacionesSummary";
import FormacionesFilters from "../components/FormacionesFilters";
import FormacionesTable from "../components/FormacionesTable";
import FormacionFormModal from "../components/FormacionFormModal";
import { usePermissions } from "../../../../utils/permissions";
import { useNavigate } from "react-router-dom";
import { showToast } from "../../../../utils/showToast";

export default function FormacionesView({
  loading,
  error,
  resumen,
  filtros,
  setFiltros,
  limpiarFiltros,
  lastUpdated,
  page,
  pageSize,
  totalPages,
  total,
  goToPage,
  formacionesPaginadas,
  seleccionado,
  setSeleccionado,
  reload,
  form,
  matriculasOptions,
  cursosOptions,
  promocionesOptions,
  loadingOptions,
  reloadOptions,
}) {
  const { hasPermission } = usePermissions();
  const navigate = useNavigate();
  const canCreate = hasPermission("formaciones.crear");
  const canUpdate = hasPermission("formaciones.actualizar");
  const canDelete = hasPermission("formaciones.eliminar");

  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    if (form.modal) document.body.classList.add("modal-open");
    else document.body.classList.remove("modal-open");
    return () => document.body.classList.remove("modal-open");
  }, [form.modal]);

  const quickFilter = (key) => {
    switch (key) {
      case "inscritos":
        setFiltros((prev) => ({ ...prev, estado: "inscrito" }));
        break;
      case "cursando":
        setFiltros((prev) => ({ ...prev, estado: "cursando" }));
        break;
      case "egresados":
        setFiltros((prev) => ({ ...prev, estado: "egresado" }));
        break;
      case "activos":
        setFiltros((prev) => ({ ...prev, activo: "1" }));
        break;
      case "inactivos":
        setFiltros((prev) => ({ ...prev, activo: "0" }));
        break;
      default:
        setFiltros((prev) => ({ ...prev, estado: "all", activo: "all", promocion: "all" }));
        break;
    }
  };

  const activeQuickFilter =
    filtros?.estado === "inscrito"
      ? "inscritos"
      : filtros?.estado === "cursando"
        ? "cursando"
          : filtros?.estado === "egresado"
            ? "egresados"
            : filtros?.activo === "1"
            ? "activos"
            : filtros?.activo === "0"
              ? "inactivos"
              : "total";

  const lastSync = lastUpdated ? lastUpdated.toLocaleString() : "Sincronización inicial";

  return (
    <section className="management-page management-theme-violet">
      <div className="management-card management-header mb-4">
        <div>
          <p className="management-eyebrow mb-1">Académico / Formaciones</p>
          <h4 className="management-title mb-1">Gestión de formaciones académicas</h4>
          <p className="text-muted mb-0">Consulta y administra las formaciones creadas para los estudiantes.</p>
        </div>
        <div className="d-flex flex-column align-items-end gap-2">
          {canCreate && (
            <button type="button" className="btn management-btn-primary" onClick={form.abrirCrear}>
              <i className="bi bi-plus-circle me-2" />
              Nueva formación
            </button>
          )}
          <small className="text-muted">Actualizado: {lastSync}</small>
        </div>
      </div>

      <FormacionesSummary resumen={resumen} onQuickFilter={quickFilter} activeKey={activeQuickFilter} />

      <FormacionesFilters
        filtros={filtros}
        setFiltros={setFiltros}
        limpiarFiltros={limpiarFiltros}
        promocionesOptions={promocionesOptions}
        promocionesLoading={loadingOptions}
      />

      <FormacionesTable
        formaciones={formacionesPaginadas}
        loading={loading}
        error={error}
        seleccionadoId={seleccionado?.id}
        onSelect={setSeleccionado}
        onEdit={canUpdate ? form.abrirEditar : undefined}
        onDelete={canDelete ? form.abrirEliminar : undefined}
        onViewHistorial={(item) => {
          const estudianteId = item?.estudianteId;
          if (!estudianteId) {
            showToast({ type: "warning", message: "Esta formación no tiene estudiante asociado." });
            return;
          }
          navigate(`/dashboard/estudiantes/${estudianteId}/detalle?tab=formacion`);
        }}
        canEdit={canUpdate}
        canDelete={canDelete}
        reload={reload}
      />

      <div className="management-card d-flex justify-content-between align-items-center flex-wrap gap-3">
        <div className="text-muted small">
          Mostrando {total === 0 ? 0 : (page - 1) * pageSize + 1}-{Math.min(total, page * pageSize)} de {total}
        </div>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <div className="btn-group">
            <button className="btn btn-outline-secondary btn-sm" onClick={() => goToPage(page - 1)} disabled={page <= 1}>
              <i className="bi bi-chevron-left" />
            </button>
            <button className="btn btn-outline-secondary btn-sm" disabled>
              Página {page} / {totalPages}
            </button>
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => goToPage(page + 1)}
              disabled={page >= totalPages}
            >
              <i className="bi bi-chevron-right" />
            </button>
          </div>
        </div>
      </div>

      <FormacionFormModal
        {...form}
        matriculasOptions={matriculasOptions}
        cursosOptions={cursosOptions}
        loadingOptions={loadingOptions}
        reloadOptions={reloadOptions}
      />
    </section>
  );
}
